import type { CTA } from '../../types';
import { safeUrl } from '../../safeUrl';

export function DeepLinkCta({ cta }: { cta: CTA }) {
  return (
    <a
      href={safeUrl(cta.url)}
      target="_blank"
      rel="noopener noreferrer"
      className="deep-link-cta"
    >
      {cta.label} ↗
    </a>
  );
}
